import { computed, ref, useAsync } from '@nuxtjs/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import GoogleMapTypeEnum from '~/components/map/types/googleMapTypes';
import useMetaTagsService from '~/composables/useMetaTagsService';
import { UseRainbowContext } from '~/context/RainbowContext';

import fillMapIcons from '../functions/fillMapIcons';
import { buildMapContainerClass, checkIsMobile, checkShouldRenderList } from '../functions/glowna';
import { useRoutePathChange } from '../functions/shared';

const { useGetters, useState, useActions } = createNamespacedHelpers('biura');

const useBiuraGlownaService = () => {
  const { miasta, koordynatyNaMape, mapCoords } = useGetters(['miasta', 'koordynatyNaMape', 'mapCoords']);
  const {
    routeInfo, miasto, wojewodztwo, szerokoscGeo, dlugoscGeo, koordynatyLoaded,
  } = useState([
    'routeInfo',
    'miasto',
    'wojewodztwo',
    'szerokoscGeo',
    'dlugoscGeo',
    'koordynatyLoaded',
  ]);
  const { initialize, routeChange } = useActions(['initialize', 'routeChange']);
  const { $ua, route } = UseRainbowContext();
  const isMobile = ref<boolean>(checkIsMobile($ua));
  const renderMap = ref<boolean>(!isMobile.value);

  fillMapIcons();

  useAsync(async () => {
    await initialize(routeInfo);
    return true;
  });

  useRoutePathChange(routeChange);

  return {
    mapContainerClass: computed(() => buildMapContainerClass(isMobile)),
    isMobile,
    miasta,
    koordynatyNaMape,
    mapType: GoogleMapTypeEnum.BIURA,
    map: ref<unknown>(),
    metaTags: computed(() => useMetaTagsService({ routeInfo, route })?.metaTags),
    shouldRenderMapContainer: computed(
      (): boolean => !koordynatyLoaded.value || (renderMap.value && koordynatyLoaded.value && koordynatyNaMape.value.length),
    ),
    isMiastoChosen: computed((): boolean => routeInfo.value && routeInfo.value.DodatkowePola && routeInfo.value.DodatkowePola.miastoUrl),
    shouldRenderMap: computed((): boolean => renderMap.value && koordynatyLoaded.value && koordynatyNaMape.value.length),
    toggleMap: () => {
      renderMap.value = !renderMap.value;
    },
    shouldRenderList: computed((): boolean => checkShouldRenderList({
      wojewodztwo,
      miasto,
      szerokoscGeo,
      dlugoscGeo,
    })),
    mapCoords,
    mapCssClass: computed(() => (isMobile.value ? 'map--mobile' : '')),
    route,
  };
};
export default useBiuraGlownaService;
